import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-modal w-maxC grid-show-bill" }
const _hoisted_2 = { style: {"grid-area":"1 / invoiceFileCol"} }
const _hoisted_3 = {
  key: 0,
  class: "row"
}
const _hoisted_4 = { class: "row gap-02 mleft-04" }
const _hoisted_5 = { class: "row-bottom" }
const _hoisted_6 = { class: "pad-l" }
const _hoisted_7 = {
  key: 0,
  style: {"min-height":"45rem","min-width":"34rem"}
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { style: {"grid-area":"1 / invoiceDataCol"} }
const _hoisted_10 = { class: "row mtop-02" }

import { ref, watch, onBeforeUnmount, onMounted } from 'vue';
import gen from '@/functions/general.js';
import patientapi from '@/api/patientapi';
import officeapi from '@/api/officeapi';
import { apiAmountCurrency, apiDateString } from '@/api/apicommon';
import PersonService from "@/services/PersonService";


export default /*@__PURE__*/_defineComponent({
  __name: 'showBill',
  props: {
    invoice: {
      type: Object,
      required: true,
    },
},
  setup(__props) {

const props = __props

//Note
const inputRef = ref(null)
const currInfo = ref(props.invoice.invoiceInfo)
const currInvoice = ref(props.invoice)
const cancellationReason = ref(props.invoice.patientDocument?.luBillEtransferData?.cancellationReason || "")

async function updateInvoiceInfo() {
  const invoiceId = props.invoice.id;
  const oldInfo = props.invoice.invoiceInfo;
  const newInfo = currInfo.value;
  if (oldInfo === newInfo) return;
  currInvoice.value.invoiceInfo = newInfo;
  await officeapi.updateInvoiceInfo(invoiceId, newInfo);
}

const patientDocument = ref(props.invoice.patientDocument)
const isLoading = ref(false);

//FINALIZATION, PRINT, ESEND
const localPdfBlob = ref(null)
const localPdfUrl = ref(null)
const hasNoDocument = ref(false)

async function showPdf() {
  await getPdf()
  if (!localPdfUrl.value) {return}
  window.open(localPdfUrl.value)
}

async function downloadPdf() {
  await getPdf()
  if (!localPdfBlob.value) {return}
  const fileName = patientDocument.value?.originalText
  const fileExtension = "pdf"
  gen.downloadBlob(localPdfBlob.value, fileName, fileExtension)
}

async function printPdf() {
  await getPdf()
  if (!localPdfBlob.value) {return}
  gen.printBlob(localPdfBlob.value, "Pdf")
}

async function getPdf() {
  if (localPdfBlob.value != null) {return;} 
  if (!patientDocument.value) {hasNoDocument.value = true; return; }
  const patientDocumentId = patientDocument.value.patientDocumentId
  if (patientDocument.value.templateStatus === 'Precomplete') {return;}

  
  try {
    isLoading.value = true;
    const respBlob = await patientapi.getPatientDocumentPdfStream(patientDocumentId)
    isLoading.value = false;
    if (!respBlob) {hasNoDocument.value = true; return; }
    localPdfBlob.value = respBlob
    const myBlob= new Blob([respBlob], {type: 'application/pdf'})
    localPdfUrl.value = window.URL.createObjectURL(myBlob)
  } finally {
    isLoading.value = false;
  }
}


watch(
  () => patientDocument.value?.patientDocumentId,
  () => {getPdf()},
  { immediate: true }
)

onMounted(() => {
  inputRef.value.innerRef.focus()
})

onBeforeUnmount(() => {
  updateInvoiceInfo();
})


return (_ctx: any,_cache: any) => {
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_inputAreaAuto2 = _resolveComponent("inputAreaAuto2")!
  const _component_inputBox = _resolveComponent("inputBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (patientDocument.value && ['Complete', 'Scheduled', 'Exported'].includes(patientDocument.value.templateStatus) && localPdfUrl.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_buttonGroup, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showPdf()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "fullScreen",
                    styles: "main-m"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_buttonGroup, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (downloadPdf()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "download",
                    styles: "main-m"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_buttonGroup, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (printPdf()))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_svg_item, {
                      icon: "printer",
                      styles: "main-l size-m"
                    })
                  ])
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (localPdfUrl.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("iframe", {
                src: localPdfUrl.value,
                scrolling: "yes",
                frameborder: "1",
                style: {"height":"45rem","width":"100%"}
              }, null, 8, _hoisted_8)
            ]))
          : (patientDocument.value?.templateStatus === 'Precomplete')
            ? (_openBlock(), _createBlock(_component_text_item, {
                key: 1,
                txt: "Mémoire non finalisé",
                styles: "main-l"
              }))
            : (isLoading.value === true)
              ? (_openBlock(), _createBlock(_component_text_item, {
                  key: 2,
                  txt: "Loading ...",
                  styles: "main-l"
                }))
              : (hasNoDocument.value)
                ? (_openBlock(), _createBlock(_component_text_item, {
                    key: 3,
                    txt: "Pas de fichier à afficher",
                    styles: "main-l"
                  }))
                : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_text_item, {
        txt: _unref(PersonService).formatName(__props.invoice.pwrCounterParty.lastName, __props.invoice.pwrCounterParty.firstName),
        styles: "font-l"
      }, null, 8, ["txt"]),
      _createVNode(_component_text_item, {
        txt: __props.invoice.invoiceReference,
        styles: "main-m",
        class: "mtop-02"
      }, null, 8, ["txt"]),
      _createVNode(_component_text_item, {
        txt: _unref(apiDateString)(__props.invoice.invoiceDateTime),
        class: "mtop-08"
      }, null, 8, ["txt"]),
      _createVNode(_component_text_item, {
        txt: _unref(apiAmountCurrency)(__props.invoice.amount, __props.invoice.currencyIso),
        class: "mtop-04"
      }, null, 8, ["txt"]),
      (cancellationReason.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_text_item, {
              txt: "Motif d'annulation",
              class: "mtop-15",
              styles: "font-mBold"
            }),
            _createVNode(_component_text_item, {
              txt: cancellationReason.value,
              class: "mtop-02"
            }, null, 8, ["txt"])
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_text_item, {
        txt: "Note",
        class: "mtop-15",
        styles: "font-mBold"
      }),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_inputBox, null, {
          default: _withCtx(() => [
            _createVNode(_component_inputAreaAuto2, {
              ref_key: "inputRef",
              ref: inputRef,
              modelValue: currInfo.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currInfo).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})